import { Component, OnInit, Input, TemplateRef } from '@angular/core';
import { HasFormComponent } from '../../../../../../shared/core/interfaces/hasFormComponent';
import { NotImplementedViewModel } from '../../../../../../shared/ui-ndms/view-models/not-implemented.view-model';
import { FormArray, FormGroup } from '@angular/forms';
import { ResponderProfileService } from '../../../../responders/shared/responder-profile/shared/services/responder-profile.service';
import { LookupService } from '../../../../../../shared/core/services/lookup.service';
import { ViewModelService } from '../../../../../../shared/core/services/view-model.service';
import { FormObjects } from '../../../../../../shared/core/utilities/formObjects';
import { RespondersHomeService } from '../../../../responders/responders-home/shared/services/responders-home.service';
import { RespondersService } from '../../../core-rms/responders.service';

@Component({
  selector: 'search-responders-multi-modal',
  templateUrl: './search-responders-multi-modal.component.html',
  styleUrls: ['./search-responders-multi-modal.component.scss']
})
export class SearchRespondersMultiModalComponent extends HasFormComponent<NotImplementedViewModel> implements OnInit {
  @Input() selectedItems: FormArray;
  @Input() wizardFormGroup: FormGroup;
  @Input() wizardForm: TemplateRef<any>;


  constructor(public searchService: RespondersService, lookupService: LookupService, viewModelService: ViewModelService) {
    super(lookupService, viewModelService, NotImplementedViewModel, false);
    
    this.form = new FormGroup({
      firstName: FormObjects.String(),
      lastName: FormObjects.String(),
      socialSecurityNumber: FormObjects.SocialSecurityNumberLastFour(),
      team: FormObjects.Lookup(),
      position: FormObjects.Lookup()
    });
  }
  ngOnInit() {
  }

  resetForm(): void {
    throw new Error("Method not implemented.");
  }
}
